// extracted by mini-css-extract-plugin
export default {"content":"BottomContent_content__KvO1E","box":"BottomContent_box__rbj1z","p":"BottomContent_p__yUOAw"};